import { useEffect } from "react";

import * as DLD from "#/def/data-layer";
import * as DLE from "#/def/lookup-tables.enums.gen";
import useAuthorization from "#/hooks/useAuthorization";
import {
  useDataLayerMutationFormHandlers,
  useDataLayerRead,
} from "#/hooks/useDataLayer";

import ProfileForm from "./components/Form";

export default function ProfilePage() {
  // find current authorization from list of available authorizations
  //
  // We will use data from the user
  // but will fetch fresh data for the breeder (subjekt) to ensure we have the latest data,
  const { current, available } = useAuthorization();
  const { uporabnik, subjekt, nivoDostopa } =
    available.find((a) => a.id === current) || {};

  const $READ = useDataLayerRead({ ident: DLD.RKG_SUBJECT });
  const $MUTATE = useDataLayerMutationFormHandlers({
    ...$READ,
    redirectTo: "/profile?",
  });

  const handleSubmit = ({ breeder }) => $MUTATE.submit(breeder);
  const isBreader = nivoDostopa === DLE.SifNivoDostopa.REJEC;

  useEffect(() => {
    if (isBreader && subjekt?.id) {
      $READ.read(subjekt.id);
    }
  }, [isBreader, subjekt?.id]);

  if (isBreader && !$READ.item) {
    // if user is breeder but we don't have breeder data yet, show loading state
    return <div>Loading...</div>;
  }

  return (
    <>
      <ProfileForm
        onSubmit={handleSubmit}
        user={uporabnik}
        breeder={$READ.item}
      />
    </>
  );
}
